// extracted by mini-css-extract-plugin
export default {"ghostPage":"ghost_page-module___ghostPage___f25f1e4a","contentPlaceholder":"ghost_page-module___contentPlaceholder___b75f6f7c"};